export default __webpack_public_path__ + "static/media/cms_mark.903c5181.jpg";